import { FC } from 'react';
import { CardTable, Button, EmptyState, ButtonGroup } from '@/_components';
import { OverviewTableFilteredEmptyProps } from './OverviewTableFilteredEmpty.types';

export const OverviewTableFilteredEmpty: FC<
  OverviewTableFilteredEmptyProps
> = ({ onResetFilters }) => {
  return (
    <CardTable isLoading={false}>
      <EmptyState description="No questionnaires found" icon="questionnaire">
        <ButtonGroup align="center">
          <Button
            intent="secondary"
            size="small"
            onClick={onResetFilters}
            value="Reset Filters"
          />
        </ButtonGroup>
      </EmptyState>
    </CardTable>
  );
};
